import { createFileRoute } from '@tanstack/react-router';

import BlogPage from '@/pages/blog/BlogPage';
import { getBlogPosts } from '@/sanity/blog';
import {
  getFooterLandingPages,
  getHomeHeaderButton,
} from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import {
  absoluteUrl,
  buildBreadcrumbSchema,
  buildPageMeta,
  buildStructuredDataScript,
  siteName,
} from '@/utils/seo';

const blogTitle = 'Landlord guides and letting agent advice — Budgy';
const blogDescription =
  "Guides for UK landlords on letting agent fees, switching agents, the Renters' Rights Act, the landlord register and Making Tax Digital.";

export const Route = createFileRoute('/blog/')({
  loader: async () => {
    const [posts, headerButton, footerLandingPages, footerLegalLinks] =
      await Promise.all([
        getBlogPosts(),
        getHomeHeaderButton(),
        getFooterLandingPages(),
        getLegalLinks(),
      ]);

    return { footerLandingPages, footerLegalLinks, headerButton, posts };
  },
  component: BlogPage,
  head: () => {
    const pageMeta = buildPageMeta({
      title: blogTitle,
      description: blogDescription,
      path: '/blog',
    });

    return {
      ...pageMeta,
      scripts: [
        buildStructuredDataScript(
          buildBreadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
          ]),
        ),
        buildStructuredDataScript({
          '@context': 'https://schema.org',
          '@type': 'Blog',
          name: blogTitle,
          description: blogDescription,
          url: absoluteUrl('/blog'),
          publisher: {
            '@type': 'Organization',
            name: siteName,
          },
        }),
      ],
    };
  },
});
